import AbstractEntity from "../AbstractEntity";

export default class Quotation extends AbstractEntity {
    _id;
    _vat;
    _validatedByFairfair;
    _validatedByPrescriber;
    _interventionId;
    _quotationItemsId;


    getId() {
        return this._id;
    }

    getVat() {
        return this._vat;
    }

    isValidatedByFairfair() {
        return this._validatedByFairfair;
    }

    isValidatedByPrescriber() {
        return this._validatedByPrescriber;
    }

    getInterventionId() {
        return this._interventionId;
    }

    getQuotationItemsId() {
        return this._quotationItemsId;
    }

    getClassName() {
        return "quotation";
    }
}
